/**
 * Static mock data extracted from the design HTML.
 * Swap this out for live API calls once the backend endpoints exist.
 */

export interface Listing {
  id: number;
  agent: string;
  addr: string;
  type: 'Rental' | 'Sale';
  status: 'active' | 'pending' | 'rejected';
  date: string;
  price: string;
  beds: number;
  baths: number;
  sqft: string;
}

export interface Lead {
  id: number;
  customer: string;
  email: string;
  phone: string;
  property: string;
  agent: string;
  date: string;
  status: 'new' | 'contacted' | 'converted';
  notes: string;
}

export interface ActivityEntry {
  t: 'pink' | 'green';
  i: string;
  text: string;
  d: string;
  time: string;
  link: 'listings' | 'leads' | 'agents' | 'legal';
}

export interface LegalSvc {
  id: number;
  name: string;
  desc: string;
  price: string;
  active: boolean;
}

export interface MaintSvc {
  id: number;
  cat: string;
  name: string;
  desc: string;
  price: string;
  active: boolean;
}

export interface MaintRequest {
  id: number;
  customer: string;
  email: string;
  phone: string;
  property: string;
  cat: string;
  issue: string;
  urgency: 'urgent' | 'normal' | 'low';
  photos: number;
  submitted: string;
  status: 'new' | 'assigned' | 'quoted' | 'accepted' | 'in-progress' | 'completed';
  provider: string | null;
  quote: string | null;
}

export interface Agent {
  id: number;
  name: string;
  email: string;
  phone: string;
  sub: 'Pro' | 'Basic' | 'None';
  lc: number;
  joined: string;
  status: 'active' | 'pending';
  rating: number | null;
  hue: number;
}

export interface Transaction {
  id: string;
  type: 'Listing Fee' | 'Commission' | 'App Fee';
  amt: string;
  who: string;
  ref: string;
  date: string;
  st: 'paid' | 'pending';
}

export interface PendingPayout {
  ag: string;
  amt: string;
  ct: number;
}

export interface SubPlan {
  id: number;
  nm: string;
  mo: number;
  yr: number;
  pop: boolean;
  st: 'active';
  subs: number;
  feats: string[];
}

export interface Subscriber {
  ag: string;
  plan: 'Free' | 'Standard' | 'Pro';
  cyc: 'Monthly' | 'Yearly' | '—';
  ren: string;
  st: 'active' | 'past-due';
}

export const listings: Listing[] = [
  { id: 1, agent: 'Marcus Johnson',     addr: '1425 Woodward Ave, Detroit',   type: 'Rental', status: 'active',   date: 'Apr 28, 2026', price: '$1,200/mo', beds: 3, baths: 2, sqft: '1,400' },
  { id: 2, agent: 'Lisa Chen',          addr: '890 Michigan Ave, Dearborn',   type: 'Sale',   status: 'pending',  date: 'May 2, 2026',  price: '$245,000',  beds: 4, baths: 3, sqft: '2,100' },
  { id: 3, agent: 'Tyraa Nicole',       addr: '3200 Gratiot Ave, Detroit',    type: 'Rental', status: 'active',   date: 'Apr 15, 2026', price: '$950/mo',   beds: 2, baths: 1, sqft: '900' },
  { id: 4, agent: 'DeShawn Williams',   addr: '567 Livernois Ave, Detroit',   type: 'Sale',   status: 'rejected', date: 'May 5, 2026',  price: '$189,000',  beds: 3, baths: 2, sqft: '1,600' },
  { id: 5, agent: 'Keisha Brown',       addr: '2100 W Grand Blvd, Detroit',   type: 'Rental', status: 'pending',  date: 'May 7, 2026',  price: '$1,450/mo', beds: 3, baths: 2, sqft: '1,350' },
  { id: 6, agent: 'Marcus Johnson',     addr: '4401 Conner St, Detroit',      type: 'Rental', status: 'active',   date: 'Mar 29, 2026', price: '$875/mo',   beds: 1, baths: 1, sqft: '650' },
];

export const leads: Lead[] = [
  { id: 1, customer: 'Jasmine Reeves',  email: 'jasmine.r@gmail.com', phone: '(313) 555-0142', property: '1425 Woodward Ave', agent: 'Marcus Johnson',    date: 'May 8, 2026', status: 'new',       notes: 'First-time renter, moving from Ohio. Wants to schedule a tour ASAP.' },
  { id: 2, customer: 'Andre Mitchell',  email: 'andre.m@outlook.com', phone: '(313) 555-0198', property: '890 Michigan Ave',  agent: 'Lisa Chen',         date: 'May 7, 2026', status: 'contacted', notes: 'Pre-approved for $260K. Very interested, asked about land contract option.' },
  { id: 3, customer: 'Tanya Okafor',    email: 'tanya.o@yahoo.com',   phone: '(248) 555-0177', property: '3200 Gratiot Ave',  agent: 'Tyraa Nicole',      date: 'May 6, 2026', status: 'converted', notes: 'Submitted rental application. Background check in progress.' },
  { id: 4, customer: 'Robert Kim',      email: 'r.kim@gmail.com',     phone: '(313) 555-0211', property: '2100 W Grand Blvd', agent: 'Keisha Brown',      date: 'May 5, 2026', status: 'new',       notes: 'Asked about pet policy and parking.' },
  { id: 5, customer: 'Maria Santos',    email: 'm.santos@live.com',   phone: '(734) 555-0165', property: '567 Livernois Ave', agent: 'DeShawn Williams',  date: 'May 3, 2026', status: 'contacted', notes: 'Interested in making an offer below asking. Wants inspection contingency.' },
];

export const activity: ActivityEntry[] = [
  { t: 'pink',  i: 'building-2',     text: 'Keisha Brown submitted a new rental listing', d: '2100 W Grand Blvd, Detroit',  time: '12 min ago', link: 'listings' },
  { t: 'pink',  i: 'message-square', text: 'New inquiry from Jasmine Reeves',             d: 'Interested in 1425 Woodward Ave', time: '28 min ago', link: 'leads' },
  { t: 'green', i: 'check-circle',   text: 'Deed Search order completed',                 d: 'Order #1047 — Robert Kim',    time: '1 hr ago',   link: 'legal' },
  { t: 'pink',  i: 'user-check',     text: 'James Petrov registered as a new merchant',      d: 'Pending approval',            time: '2 hr ago',   link: 'agents' },
  { t: 'green', i: 'dollar-sign',    text: 'Payment received: Eviction Consultation',     d: '$50.00 via Stripe',           time: '3 hr ago',   link: 'legal' },
  { t: 'pink',  i: 'pencil',         text: 'Marcus Johnson updated listing photos',       d: '4401 Conner St, Detroit',     time: '5 hr ago',   link: 'listings' },
];

export const legalServices: LegalSvc[] = [
  { id: 1,  name: 'Deed Search',           desc: 'Find current property owner on record',                                              price: '$10',           active: true  },
  { id: 2,  name: 'Quit Claim Deed',       desc: 'Ownership transfer preparation & recording',                                         price: '$250',          active: true  },
  { id: 3,  name: 'Foreclosure Lists',     desc: 'Michigan foreclosure/land contract lists, emailed within 24hrs',                     price: '$10 each',      active: true  },
  { id: 4,  name: 'Eviction Services',     desc: 'Full court hearings through judgment; writ, bailiff, locksmith extra',               price: 'From $350',     active: true  },
  { id: 5,  name: 'Eviction Consultation', desc: 'Phone, virtual + follow-ups',                                                        price: '$25 / $50 / $100', active: true },
  { id: 6,  name: 'Real Estate Consulting',desc: 'Virtual or in-person expert consultation',                                           price: '$25 / $50',     active: false },
  { id: 7,  name: 'LLC Setup',             desc: 'LLC preparation & EIN; operating agreement add-on $100',                             price: '$150',          active: true  },
  { id: 8,  name: 'Notary Services',       desc: 'Mobile notary available; fee varies by location',                                    price: 'At service',    active: true  },
  { id: 9,  name: 'Lease Preparation',     desc: 'Professional lease document preparation',                                            price: '$75',           active: true  },
  { id: 10, name: 'Tenant Placement',      desc: 'Full service from start to finish including lease prep',                             price: '1 month rent',  active: true  },
];

export const maintServices: MaintSvc[] = [
  { id: 1, cat: 'Cleaning',    name: 'Move-In / Move-Out Cleaning', desc: 'Deep clean for tenant transitions',           price: 'From $200',      active: true  },
  { id: 2, cat: 'Cleaning',    name: 'Deep Cleaning',               desc: 'Comprehensive residential deep clean',         price: 'From $150',      active: true  },
  { id: 3, cat: 'Repairs',     name: 'Plumbing Repair',             desc: 'Leak fixes, drain clearing, fixture install',  price: 'From $85/hr',    active: true  },
  { id: 4, cat: 'Repairs',     name: 'Electrical Repair',           desc: 'Outlet, switch, and fixture troubleshooting',  price: 'From $90/hr',    active: true  },
  { id: 5, cat: 'Renovation',  name: 'Interior Painting',           desc: 'Room painting with prep and materials',        price: 'From $300/room', active: true  },
  { id: 6, cat: 'Renovation',  name: 'Drywall Repair',              desc: 'Patch, mud, and texture matching',             price: 'From $120',      active: false },
  { id: 7, cat: 'Landscaping', name: 'Lawn Maintenance',            desc: 'Mowing, edging, and cleanup',                  price: 'From $50/visit', active: true  },
  { id: 8, cat: 'Pest Control',name: 'Pest Treatment',              desc: 'Inspection and treatment for common pests',    price: 'From $125',      active: true  },
  { id: 9, cat: 'General',     name: 'General Handyman',            desc: 'Minor repairs, mounting, assembly',            price: 'From $65/hr',    active: true  },
];

export const maintRequests: MaintRequest[] = [
  { id: 101, customer: 'Tanya Okafor',   email: 'tanya.o@gmail.com',  phone: '(313) 555-2847', property: '3200 Gratiot Ave, Detroit',   cat: 'Plumbing',    issue: 'Leaking kitchen faucet — water pooling under the sink. Needs urgent repair before it damages the cabinet.', urgency: 'urgent', photos: 2, submitted: 'May 12, 2026', status: 'new',         provider: null,                quote: null      },
  { id: 102, customer: 'Andre Mitchell', email: 'andre.m@outlook.com',phone: '(313) 555-6190', property: '890 Michigan Ave, Unit 4B',    cat: 'Electrical',  issue: 'Three outlets in the living room stopped working. Breaker resets but trips again within minutes.',           urgency: 'normal', photos: 1, submitted: 'May 11, 2026', status: 'assigned',    provider: 'Marcus Johnson',    quote: null      },
  { id: 103, customer: 'Jasmine Reeves', email: 'jasmine.r@gmail.com',phone: '(313) 555-4033', property: '1425 Woodward Ave, Apt 7',     cat: 'Cleaning',    issue: 'Full move-out deep clean requested. 2BR/1BA unit. Tenant vacated May 9.',                                    urgency: 'normal', photos: 0, submitted: 'May 10, 2026', status: 'quoted',      provider: 'DeShawn Williams',  quote: '$275.00' },
  { id: 104, customer: 'Robert Kim',     email: 'r.kim@mail.com',     phone: '(313) 555-8821', property: '567 Livernois Ave',            cat: 'General',     issue: 'Need towel bar and 2 shelving units mounted in bathroom. Drywall walls.',                                   urgency: 'low',    photos: 3, submitted: 'May 9, 2026',  status: 'accepted',    provider: 'Lisa Chen',         quote: '$120.00' },
  { id: 105, customer: 'Maria Santos',   email: 'maria.s@gmail.com',  phone: '(313) 555-1457', property: '4401 Conner St',               cat: 'Pest Control',issue: 'Tenant reporting roach sighting in kitchen area. Requesting inspection and treatment.',                     urgency: 'urgent', photos: 0, submitted: 'May 8, 2026',  status: 'in-progress', provider: 'Marcus Johnson',    quote: '$150.00' },
  { id: 106, customer: 'DeAndre Powell', email: 'dpow@gmail.com',     phone: '(313) 555-7744', property: '2100 W Grand Blvd, Unit 2',    cat: 'Repairs',     issue: "Bathroom door handle is broken and won't latch. Also the towel rack is falling off the wall.",                urgency: 'normal', photos: 1, submitted: 'May 7, 2026',  status: 'completed',   provider: 'Lisa Chen',         quote: '$95.00'  },
];

export const agents: Agent[] = [
  { id: 1, name: 'Marcus Johnson',   email: 'marcus.j@realtymi.com',  phone: '(313) 555-0134', sub: 'Pro',   lc: 12, joined: 'Jan 15, 2026', status: 'active',  rating: 4.8,  hue: 60  },
  { id: 2, name: 'Lisa Chen',        email: 'lisa.chen@homesmi.com',  phone: '(248) 555-0192', sub: 'Basic', lc: 5,  joined: 'Feb 20, 2026', status: 'active',  rating: 4.6,  hue: 120 },
  { id: 3, name: 'DeShawn Williams', email: 'deshawn.w@gmail.com',    phone: '(313) 555-0156', sub: 'Pro',   lc: 8,  joined: 'Mar 3, 2026',  status: 'pending', rating: 4.9,  hue: 180 },
  { id: 4, name: 'Keisha Brown',     email: 'keisha.b@outlook.com',   phone: '(734) 555-0178', sub: 'Basic', lc: 3,  joined: 'Apr 1, 2026',  status: 'active',  rating: 4.5,  hue: 240 },
  { id: 5, name: 'James Petrov',     email: 'james.p@yahoo.com',      phone: '(313) 555-0200', sub: 'None',  lc: 0,  joined: 'May 6, 2026',  status: 'pending', rating: null, hue: 300 },
];

export const transactions: Transaction[] = [
  { id: 'TXN-1047', type: 'Listing Fee', amt: '$50.00', who: 'Marcus Johnson',     ref: '1425 Woodward Ave',     date: 'May 8, 2026', st: 'paid'    },
  { id: 'TXN-1046', type: 'Commission',  amt: '$35.00', who: 'Jasmine Reeves',     ref: 'Eviction Consultation', date: 'May 7, 2026', st: 'paid'    },
  { id: 'TXN-1045', type: 'App Fee',     amt: '$35.00', who: 'Tanya Okafor',       ref: '3200 Gratiot Ave',      date: 'May 6, 2026', st: 'paid'    },
  { id: 'TXN-1044', type: 'Listing Fee', amt: '$50.00', who: 'Lisa Chen',          ref: '890 Michigan Ave',      date: 'May 5, 2026', st: 'pending' },
  { id: 'TXN-1043', type: 'Commission',  amt: '$25.00', who: 'Robert Kim',         ref: 'Deed Search',           date: 'May 4, 2026', st: 'paid'    },
  { id: 'TXN-1042', type: 'Listing Fee', amt: '$50.00', who: 'DeShawn Williams',   ref: '567 Livernois Ave',     date: 'May 3, 2026', st: 'paid'    },
  { id: 'TXN-1041', type: 'Commission',  amt: '$52.50', who: 'Maria Santos',       ref: 'Eviction Services',     date: 'May 2, 2026', st: 'pending' },
  { id: 'TXN-1040', type: 'App Fee',     amt: '$35.00', who: 'Andre Mitchell',     ref: '890 Michigan Ave',      date: 'May 1, 2026', st: 'paid'    },
];

export const pendingPayouts: PendingPayout[] = [
  { ag: 'Marcus Johnson',   amt: '$320.00', ct: 6 },
  { ag: 'Lisa Chen',        amt: '$185.00', ct: 3 },
  { ag: 'DeShawn Williams', amt: '$95.00',  ct: 2 },
];

export const subscriptionPlans: SubPlan[] = [
  { id: 1, nm: 'Free',     mo: 0,  yr: 0,   pop: false, st: 'active', subs: 2, feats: ['Up to 3 listings','Basic inquiry notifications','Rentagade default application form','No featured listings'] },
  { id: 2, nm: 'Standard', mo: 29, yr: 290, pop: true,  st: 'active', subs: 8, feats: ['Up to 15 listings','Priority inquiry notifications','Custom application URL','2 featured listing slots','Basic analytics'] },
  { id: 3, nm: 'Pro',      mo: 79, yr: 790, pop: false, st: 'active', subs: 5, feats: ['Unlimited listings','Instant inquiry alerts','Custom application URL','Unlimited featured listings','Advanced analytics','Priority support','Early access to new features'] },
];

export const subscribers: Subscriber[] = [
  { ag: 'Marcus Johnson',    plan: 'Pro',      cyc: 'Monthly', ren: 'Jun 15, 2026', st: 'active'   },
  { ag: 'Lisa Chen',         plan: 'Standard', cyc: 'Yearly',  ren: 'Feb 20, 2027', st: 'active'   },
  { ag: 'Keisha Brown',      plan: 'Standard', cyc: 'Monthly', ren: 'May 1, 2026',  st: 'past-due' },
  { ag: 'DeShawn Williams',  plan: 'Pro',      cyc: 'Monthly', ren: 'Jun 3, 2026',  st: 'active'   },
  { ag: 'James Petrov',      plan: 'Free',     cyc: '—',       ren: '—',            st: 'active'   },
];

export interface NavItem {
  id: string;
  label: string;
  icon: string;
  /** Route; omitted for a group header. */
  path?: string;
  sub?: boolean;
  divider?: boolean;
  /** Collapsible group header (not a link); its items carry `group: <this id>`. */
  header?: boolean;
  /** Id of the group header this item sits under. */
  group?: string;
}

export const NAV: NavItem[] = [
  { id: 'dashboard',     label: 'Dashboard',          icon: 'layout-dashboard', path: '/admin' },
  // People and day-to-day work.
  { id: 'agents',        label: 'Merchant',           icon: 'users',            path: '/admin/agents', divider: true },
  { id: 'users',         label: 'Users',              icon: 'user',             path: '/admin/users' },
  { id: 'listings',      label: 'Buy / Rent Listing', icon: 'building-2',       path: '/admin/listings' },
  { id: 'leads',         label: 'Leads & Inquiries',  icon: 'message-square',   path: '/admin/leads' },
  { id: 'applications',  label: 'Rental Application', icon: 'file-text',        path: '/admin/applications' },
  { id: 'servicerequests', label: 'Service Order',    icon: 'wrench',           path: '/admin/service-requests' },
  { id: 'orders',        label: 'Legal Services Request', icon: 'dollar-sign',  path: '/admin/orders' },
  // { id: 'maintenance',   label: 'Maintenance',        icon: 'wrench',           path: '/admin/maintenance' },
  // Master data the app reads — catalogues and legal pages.
  { id: 'master',        label: 'Master Management',  icon: 'list',             header: true, divider: true },
  { id: 'categories',    label: 'Service Category',   icon: 'package',          path: '/admin/service-categories', sub: true, group: 'master' },
  { id: 'legal',         label: 'Legal Services',     icon: 'scale',            path: '/admin/legal', sub: true, group: 'master' },
  { id: 'terms',         label: 'Terms and Conditions', icon: 'file-text',      path: '/admin/policies/terms-of-service', sub: true, group: 'master' },
  { id: 'privacy',       label: 'Privacy Policy',     icon: 'shield',           path: '/admin/policies/privacy-policy', sub: true, group: 'master' },
  { id: 'delete-account', label: 'Delete Account Page', icon: 'user-x',         path: '/admin/policies/delete-account', sub: true, group: 'master' },
  // Money.
  { id: 'revenue',       label: 'Revenue',            icon: 'bar-chart-3',      path: '/admin/revenue', divider: true },
  { id: 'subscriptions', label: 'Subscription Plans', icon: 'credit-card',      path: '/admin/subscriptions' },
  { id: 'settings',      label: 'Settings',           icon: 'settings',         path: '/admin/settings', divider: true },
];

export const PAGE_META: Record<string, { title: string; subtitle: string }> = {
  '/admin':                { title: 'Dashboard',              subtitle: "Welcome back. Here's your platform overview." },
  '/admin/listings':       { title: 'Listings Management',    subtitle: '6 total property listings' },
  '/admin/listings/new':   { title: 'Add Listing',            subtitle: 'Create a new property listing' },
  '/admin/revenue':        { title: 'Revenue',                subtitle: 'Track earnings, commissions, and manage payouts' },
  '/admin/leads':          { title: 'Leads & Inquiries',      subtitle: '5 customer inquiries' },
  '/admin/legal':          { title: 'Legal Services',         subtitle: 'Manage your in-house legal service catalog' },
  '/admin/orders':         { title: 'Legal Services Request', subtitle: 'Legal service bookings from the app — view details and update status' },
  '/admin/service-requests': { title: 'Service Order',        subtitle: 'Maintenance service orders from the app — view details and update status' },
  '/admin/applications':   { title: 'Rental Application',      subtitle: 'Rental applications from the app — review and update status' },
  '/admin/service-categories': { title: 'Service Categories', subtitle: 'Manage the categories shown on the Services screen' },
  '/admin/maintenance':    { title: 'Property Maintenance',   subtitle: 'Manage service requests, providers, and catalog' },
  '/admin/agents':         { title: 'Merchant',               subtitle: 'All registered merchants' },
  '/admin/users':          { title: 'Users',                  subtitle: 'People using the Rentagade app — open a user to see all their activity' },
  '/admin/subscriptions':  { title: 'Subscription Plans',     subtitle: 'Manage merchant subscription tiers and billing' },
  '/admin/policies/terms-of-service': { title: 'Terms and Conditions', subtitle: 'Edit the terms shown on the website and apps' },
  '/admin/policies/privacy-policy':   { title: 'Privacy Policy',       subtitle: 'Edit the privacy policy shown on the website and apps' },
  '/admin/policies/delete-account':   { title: 'Delete Account Page',  subtitle: 'Edit the account-deletion instructions the apps and stores link to' },
  '/admin/settings':       { title: 'Settings',               subtitle: 'Your admin profile, password, platform, Stripe and pricing settings' },
};
